import React from "react";
import { Button } from "../../../Common/Buttons/Button";
import { IconNames } from "../../../Common/Icons/LucideIcons";

export const OperationsMenuButton = ({
  text,
  onClick,
  icon,
  disabled,
}: {
  text: string;
  onClick: () => void;
  icon: IconNames;
  disabled?: boolean;
}) => (
  <Button
    iconStart={icon}
    variant="outline"
    size="small"
    onPress={onClick}
    isDisabled={disabled}
    title={text}
  />
);

export default OperationsMenuButton;
